<div class="main-content">
  <app-side-menu></app-side-menu>
  <div class="right-content">
    <app-top-menu></app-top-menu>
    @if (isload) {
      <div class="loading-animation">
        <app-loading></app-loading>
      </div>
    }
    @if (!isload) {
      <div class="content">
        <div class="back-btn">
          <button class="btn" (click)="goToCampaigns()" style="float: left">
            <img src="../../assets/Icons/arrow-left-line.png" alt="Back" />
          </button>
          <span style="overflow: hidden;">
            Campanhas /
          </span>
          <span class="separador">
            {{campaign?.name}}
          </span>
        </div>
        @if (!(showCampaignImage().endsWith('mp4') || showCampaignImage().endsWith('webm'))) {
          <div>
            <img [src]="showCampaignImage()" alt="Imagem da Campanha" class="img-campanha" />
          </div>
        }
        @if (showCampaignImage().endsWith('mp4') || showCampaignImage().endsWith('webm')) {
          <div>
            <video autoplay muted loop [src]="showCampaignImage()" alt="Imagem da Campanha" class="img-campanha"></video>
          </div>
        }
        @if (campaign && campaign.pdf && campaign.pdf !== '') {
          <div class="file" (click)="onFileClick(campaign.pdf)">
            <mat-icon> attach_file</mat-icon>
            <span>{{ getOriginalFileName(campaign.pdf) }}</span>
          </div>
        }
        @if (campaign?.group?.length! > 0) {
          <div class="div-span">
            <span class="span-inter">
              Grupos em Destaque
            </span>
          </div>
        }
        @if (campaign?.group?.length! > 0) {
          <div class="d-flex flex-row aligments">
            @for (group of campaign?.group; track group) {
              @if (!(showGroupImage(group).endsWith('mp4') || showGroupImage(group).endsWith('webm'))) {
                <div
                  class="d-flex justify-content-center" (click)="goToGroup(group)" class="img-grupo">
                  <img class="banner" [src]="showGroupImage(group)" />
                </div>
              }
              @if (showGroupImage(group).endsWith('mp4') || showGroupImage(group).endsWith('webm')) {
                <div>
                  <video autoplay muted loop [src]="showGroupImage(group)" alt="Imagem da Campanha" class="img-grupo"
                  (click)="goToGroup(group)"></video>
                </div>
              }
            }
          </div>
        }
      </div>
    }
    <div>
      <ng-container>
        <div class="content">
          @if (campaign?.products?.length! > 0) {
            <div class="div-span">
              <span class="span-inter">
                Produtos em Destaque
              </span>
            </div>
          }
          <div class="mt-4">
            <div class="d-flex flex-row flex-wrap justify-content-start" style="gap:20px">
              @for (product of campaign?.products; track product) {
                <app-product-shop [product]="product">
                </app-product-shop>
              }
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <app-footer></app-footer>
  </div>
</div>
